(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["bozetto-cart-reward"] && !Shopify.designMode) return;
  try {
    (function () {
    // Install one shared observer for cart mutations, no matter how many reward blocks render.
    if (!window.bzCartObserverInstalled) {
      window.bzCartObserverInstalled = true;
      var CART_URL = /\/cart\/(add|change|update|clear)/;
      var notify = function () {
        setTimeout(function () {
          document.dispatchEvent(new CustomEvent('bz:cart-changed'));
        }, 300);
      };
      var nativeFetch = window.fetch;
      window.fetch = function (input) {
        var url = (input && input.url) || input || '';
        var request = nativeFetch.apply(this, arguments);
        if (typeof url === 'string' && CART_URL.test(url)) request.then(notify, function () {});
        return request;
      };
      var nativeOpen = XMLHttpRequest.prototype.open;
      XMLHttpRequest.prototype.open = function (method, url) {
        if (typeof url === 'string' && CART_URL.test(url)) this.addEventListener('load', notify);
        return nativeOpen.apply(this, arguments);
      };
      ['cart:update', 'cart:updated', 'cart:refresh', 'cart:change'].forEach(function (name) {
        document.addEventListener(name, notify);
      });
    }

    if (customElements.get('bz-cart-reward')) return;

    var GIFT = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><rect x="3.5" y="8.5" width="17" height="4"/><path d="M5 12.5V20h14v-7.5"/><path d="M12 8.5V20"/><path d="M12 8.5S9.6 8.5 8.5 7 8.4 3.8 10 3.8s2 4.7 2 4.7zM12 8.5s2.4 0 3.5-1.5.1-3.2-1.5-3.2-2 4.7-2 4.7z"/></svg>';
    var GIFT_SM = GIFT.replace('stroke-width="1.9"', 'stroke-width="2.2"');
    var CHECK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12.5l4.5 4.5L19 7"/></svg>';

    class BzCartReward extends HTMLElement {
      connectedCallback() {
        this.step = parseInt(this.dataset.step, 10) || 4;
        this.types = (this.dataset.productTypes || '').split(',').map(function (t) { return t.trim(); }).filter(Boolean);
        try {
          this.copy = JSON.parse(this.querySelector('[data-bz-copy]').textContent);
        } catch (error) {
          this.copy = {};
        }
        // Shopify trims text settings on save, so spacing between the parts is added in render().
        for (var key in this.copy) {
          this.copy[key] = (this.copy[key] || '').trim();
        }
        this.onCartChanged = this.refresh.bind(this);
        document.addEventListener('bz:cart-changed', this.onCartChanged);
        this.render(parseInt(this.dataset.count, 10) || 0);
      }

      disconnectedCallback() {
        document.removeEventListener('bz:cart-changed', this.onCartChanged);
      }

      part(name) {
        return this.querySelector('[data-bz-' + name + ']');
      }

      unitCount(items) {
        var types = this.types;
        return items.reduce(function (total, item) {
          return !types.length || types.indexOf(item.product_type) > -1 ? total + item.quantity : total;
        }, 0);
      }

      refresh() {
        var self = this;
        fetch(window.Shopify && Shopify.routes ? Shopify.routes.root + 'cart.js' : '/cart.js', { headers: { Accept: 'application/json' } })
          .then(function (response) { return response.json(); })
          .then(function (cart) { self.render(self.unitCount(cart.items || [])); })
          .catch(function () {});
      }

      render(count) {
        var c = this.copy;
        var step = this.step;
        var rem = count % step;
        var done = count > 0 && rem === 0;
        var free = Math.floor(count / step);
        var filled = done ? step : rem;
        // Artworks left until (and including) the free one.
        var need = step - rem;
        var badge = this.part('badge');
        var line = this.part('line');
        var pips = '';

        for (var i = 0; i < step; i++) {
          var on = i < filled;
          var gift = i === step - 1;
          var next = gift && !done && filled === step - 1;
          pips += '<span class="bz-pip' + (gift ? ' gift' : '') + (on ? ' on' : '') + (next ? ' next' : '') + '">' + (gift ? GIFT_SM : on ? CHECK : '') + '</span>';
        }

        this.part('pips').innerHTML = pips;
        this.part('fill').style.width = (filled / step) * 100 + '%';
        this.querySelector('.bz').classList.toggle('bz-win', done);
        this.part('kick').innerHTML = c.kicker + ' <span class="hl">' + c.kickerHighlight + '</span>';

        if (count === 0) {
          badge.className = 'bz-badge gift';
          badge.innerHTML = GIFT;
          line.innerHTML = c.emptyLine + ' <span class="free">' + c.emptyFree + '</span>.';
        } else if (done) {
          badge.className = 'bz-badge gift';
          badge.innerHTML = GIFT;
          line.innerHTML = '<span class="free">' + (free > 1 ? free + ' ' + c.doneMany : c.doneOne) + '</span> ' + c.doneSuffix;
        } else if (need === 1) {
          badge.className = 'bz-badge';
          badge.innerHTML = '<span class="n">1</span>';
          line.innerHTML = c.addMore + ' <span class="g">' + c.oneMore + '</span> – <span class="free">' + c.oneMoreFree + '</span>';
        } else {
          badge.className = 'bz-badge';
          badge.innerHTML = '<span class="n">' + need + '</span>';
          line.innerHTML = c.addMore + ' <span class="g">' + need + ' ' + c.manyMore + '</span> – <span class="free">' + c.manyMoreFree + '</span>.';
        }
      }
    }

    customElements.define('bz-cart-reward', BzCartReward);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["bozetto-delivery-info"] && !Shopify.designMode) return;
  try {
    // Leveransdatum. Rakningen maste vara ratt varje dag om aret, darfor:
  //
  // Arbetsdag = mandag-fredag, minus de tretton allmanna helgdagarna, minus
  // midsommarafton, julafton och nyarsafton. Den avgransningen ar inte
  // hemmasnickrad: den star i semesterlagen 3 a §, i PTS tillstandsvillkor
  // for PostNord, och DSV (tidigare Schenker) sager sjalva att de levererar
  // "helgfria vardagar".
  //
  // Pasken raknas ut ur artalet i stallet for att slas upp i en tabell. En
  // tabell tar slut, och da blir datumet tyst fel nagon gang i framtiden.
  //
  // Dagen hamtas i Europe/Stockholm, aldrig i UTC och aldrig i kundens egen
  // zon. UTC ligger pa fel datum tva timmar varje natt.
  //
  // Shopify skriver sjalva att ett Liquid-renderat 'now' kan vara aldre an
  // sidvisningen, darfor raknas datumet har och inte i mallen.
  (function () {
    var VECKODAG = ['sön', 'mån', 'tis', 'ons', 'tors', 'fre', 'lör'];
    var MANAD = ['jan', 'feb', 'mars', 'apr', 'maj', 'juni',
                 'juli', 'aug', 'sep', 'okt', 'nov', 'dec'];
    var cacheStangda = {};

    function tva(n) { return n < 10 ? '0' + n : '' + n; }
    function nyckel(d) { return d[0] + '-' + tva(d[1]) + '-' + tva(d[2]); }
    function tillDatum(d) { return new Date(Date.UTC(d[0], d[1] - 1, d[2])); }
    function franDatum(x) {
      return [x.getUTCFullYear(), x.getUTCMonth() + 1, x.getUTCDate()];
    }
    function plusDagar(d, n) {
      var x = tillDatum(d);
      x.setUTCDate(x.getUTCDate() + n);
      return franDatum(x);
    }

    // Anonym gregoriansk algoritm
    function paskdagen(ar) {
      var a = ar % 19, b = Math.floor(ar / 100), c = ar % 100;
      var d = Math.floor(b / 4), e = b % 4, f = Math.floor((b + 8) / 25);
      var g = Math.floor((b - f + 1) / 3);
      var h = (19 * a + b - d - g + 15) % 30;
      var i = Math.floor(c / 4), k = c % 4;
      var L = (32 + 2 * e + 2 * i - h - k) % 7;
      var m = Math.floor((a + 11 * h + 22 * L) / 451);
      var tal = h + L - 7 * m + 114;
      return [ar, Math.floor(tal / 31), (tal % 31) + 1];
    }

    function stangdaFor(ar) {
      if (cacheStangda[ar]) return cacheStangda[ar];
      var p = paskdagen(ar), s = {};
      function satt(d) { s[nyckel(d)] = true; }
      satt([ar, 1, 1]);                 // nyarsdagen
      satt([ar, 1, 6]);                 // trettondedag jul
      satt(plusDagar(p, -2));           // langfredagen
      satt(p);                          // paskdagen
      satt(plusDagar(p, 1));            // annandag pask
      satt([ar, 5, 1]);                 // forsta maj
      satt(plusDagar(p, 39));           // kristi himmelsfardsdag
      satt(plusDagar(p, 49));           // pingstdagen
      satt([ar, 6, 6]);                 // nationaldagen
      var ms = [ar, 6, 20];             // midsommardagen: lordagen 20-26 juni
      while (tillDatum(ms).getUTCDay() !== 6) ms = plusDagar(ms, 1);
      satt(ms);
      satt(plusDagar(ms, -1));          // midsommarafton
      var ah = [ar, 10, 31];            // alla helgons dag: lordagen 31 okt-6 nov
      while (tillDatum(ah).getUTCDay() !== 6) ah = plusDagar(ah, 1);
      satt(ah);
      satt([ar, 12, 24]);               // julafton
      satt([ar, 12, 25]);               // juldagen
      satt([ar, 12, 26]);               // annandag jul
      satt([ar, 12, 31]);               // nyarsafton
      cacheStangda[ar] = s;
      return s;
    }

    function arArbetsdag(d) {
      var v = tillDatum(d).getUTCDay();
      if (v === 0 || v === 6) return false;
      return !stangdaFor(d[0])[nyckel(d)];
    }

    function laggArbetsdagar(start, antal) {
      var d = start, kvar = antal, varv = 0;
      while (kvar > 0 && varv < 400) {
        d = plusDagar(d, 1);
        varv++;
        if (arArbetsdag(d)) kvar--;
      }
      return d;
    }

    // Kalenderdag och timme i Stockholm, oavsett var kunden sitter
    function stockholmNu(nu) {
      var f = new Intl.DateTimeFormat('sv-SE', {
        timeZone: 'Europe/Stockholm', year: 'numeric', month: '2-digit',
        day: '2-digit', hour: '2-digit', minute: '2-digit', hourCycle: 'h23'
      });
      var del = {};
      f.formatToParts(nu).forEach(function (p) { del[p.type] = p.value; });
      return { dag: [+del.year, +del.month, +del.day], timme: +del.hour % 24 };
    }

    function datumText(a, b) {
      var va = VECKODAG[tillDatum(a).getUTCDay()];
      var vb = VECKODAG[tillDatum(b).getUTCDay()];
      if (nyckel(a) === nyckel(b)) return va + ' ' + a[2] + ' ' + MANAD[a[1] - 1];
      if (a[1] === b[1]) {
        return va + ' ' + a[2] + '–' + vb + ' ' + b[2] + ' ' + MANAD[b[1] - 1];
      }
      return va + ' ' + a[2] + ' ' + MANAD[a[1] - 1] + '–' +
             vb + ' ' + b[2] + ' ' + MANAD[b[1] - 1];
    }

    // Byggs med textnoder, aldrig innerHTML: mallen kommer fran temaeditorn
    function skriv(el, mall, datum, tid) {
      var bitar = mall.split(/(\{datum\}|\{tid\})/);
      var frag = document.createDocumentFragment();
      bitar.forEach(function (b) {
        if (!b) return;
        if (b === '{datum}' || b === '{tid}') {
          var stark = document.createElement('b');
          stark.textContent = b === '{datum}' ? datum : tid;
          frag.appendChild(stark);
        } else {
          frag.appendChild(document.createTextNode(b));
        }
      });
      el.textContent = '';
      el.appendChild(frag);
    }

    function rita(el, nu) {
      var min = parseInt(el.getAttribute('data-min'), 10) || 2;
      var max = parseInt(el.getAttribute('data-max'), 10) || 3;
      var cutoff = parseInt(el.getAttribute('data-cutoff'), 10);
      if (isNaN(cutoff)) cutoff = 14;
      if (max < min) max = min;

      var s = stockholmNu(nu);

      // Klockan sitter i kundens enhet och kan vara felstalld. Ligger den mer
      // an ett dygn fran det servern sa nar sidan byggdes litar vi inte pa
      // den, utan later reservtexten sta tills /cart.js svarat.
      var serverdag = el.getAttribute('data-serverdag');
      if (!el.hasAttribute('data-fran-server') && serverdag) {
        var glapp = Math.abs(tillDatum(s.dag) - new Date(serverdag + 'T00:00:00Z'));
        if (glapp > 36 * 3600 * 1000) return;
      }

      var start = s.dag;
      var hinner = arArbetsdag(start) && s.timme < cutoff;
      if (!hinner) {
        do { start = plusDagar(start, 1); } while (!arArbetsdag(start));
      }

      var mall = hinner
        ? el.getAttribute('data-mall-fore')
        : el.getAttribute('data-mall-efter');
      if (!mall) return;

      var text = el.querySelector('.bz-delivery__eta-text') || el;
      skriv(text, mall,
        datumText(laggArbetsdagar(start, min), laggArbetsdagar(start, max)),
        tva(cutoff) + '.00');
      el.setAttribute('data-klar', '1');
    }

    function kor(nu, franServer) {
      var lista = document.querySelectorAll('[data-bz-eta]');
      Array.prototype.forEach.call(lista, function (el) {
        if (franServer) el.setAttribute('data-fran-server', '1');
        rita(el, nu);
      });
    }

    // Serverns ogonblick. /cart.js cachas inte och Date-headern tickar i
    // realtid, sa den ar sann aven nar kundens klocka inte ar det.
    function franServern() {
      if (!window.fetch) return;
      fetch('/cart.js', { cache: 'no-store', credentials: 'same-origin' })
        .then(function (r) {
          var d = r.headers.get('Date');
          if (!d) return;
          var t = new Date(d);
          if (!isNaN(t.getTime())) kor(t, true);
        })
        .catch(function () { /* reservtexten star kvar */ });
    }

    function start() {
      if (!window.Intl || !Intl.DateTimeFormat) return;  // reservtexten star kvar
      kor(new Date(), false);
      franServern();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start);
    } else {
      start();
    }

    // Horizon bygger om produktkolumnen vid variantbyte. Rita om det som
    // kommit tillbaka utan datum.
    var vantar = null;
    new MutationObserver(function () {
      if (vantar) return;
      vantar = setTimeout(function () {
        vantar = null;
        if (document.querySelector('[data-bz-eta]:not([data-klar])')) start();
      }, 150);
    }).observe(document.documentElement, { childList: true, subtree: true });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["bozetto-product-guides"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bz-product-guides')) {
    class BzProductGuides extends HTMLElement {
      connectedCallback() {
        this.addEventListener('click', this.onClick);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
      }

      onClick = (event) => {
        const toggle = event.target.closest('.bzg-item');
        if (toggle) {
          const wasOpen = toggle.getAttribute('aria-expanded') === 'true';
          this.closeAll();
          if (!wasOpen) this.open(toggle);
          return;
        }
        if (event.target.closest('.bzg-close')) this.closeAll(true);
      };

      open(toggle) {
        const panel = this.querySelector(`#${toggle.getAttribute('aria-controls')}`);
        if (!panel) return;
        toggle.setAttribute('aria-expanded', 'true');
        panel.classList.add('is-open');
        panel.querySelector('.bzg-inner')?.removeAttribute('inert');
      }

      closeAll(restoreFocus = false) {
        const openToggle = this.querySelector('.bzg-item[aria-expanded="true"]');
        this.querySelectorAll('.bzg-item').forEach((item) => item.setAttribute('aria-expanded', 'false'));
        this.querySelectorAll('.bzg-panel').forEach((panel) => {
          panel.classList.remove('is-open');
          panel.querySelector('.bzg-inner')?.setAttribute('inert', '');
        });
        if (restoreFocus) openToggle?.focus();
      }
    }

    customElements.define('bz-product-guides', BzProductGuides);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["bozetto-review-carousel"] && !Shopify.designMode) return;
  try {
    class BzReviewCarousel extends HTMLElement {
    connectedCallback() {
      this.slides = [...this.querySelectorAll('[data-bzr-slide]')];
      if (!this.slides.length) return;

      this.index = 0;
      this.counter = this.querySelector('[data-bzr-current]');
      this.interval = Number(this.dataset.interval) || 5000;
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      this.querySelector('[data-bzr-prev]')?.addEventListener('click', () => this.go(this.index - 1, true));
      this.querySelector('[data-bzr-next]')?.addEventListener('click', () => this.go(this.index + 1, true));

      for (const event of ['mouseenter', 'focusin']) this.addEventListener(event, () => this.stop());
      for (const event of ['mouseleave', 'focusout']) this.addEventListener(event, () => this.start());

      this.go(0);
      this.start();
    }

    disconnectedCallback() {
      this.stop();
    }

    go(nextIndex, userInitiated = false) {
      const total = this.slides.length;
      const previous = this.index;
      this.index = (nextIndex + total) % total;
      // Only the outgoing and incoming slides change; touching all of them every tick
      // produced hundreds of needless attribute mutations per minute.
      this.slides.forEach((slide, i) => {
        const active = i === this.index;
        if (this.initialized && i !== previous && !active) return;
        slide.classList.toggle('is-active', active);
        slide.inert = !active;
        slide.setAttribute('aria-hidden', String(!active));
      });
      this.initialized = true;
      if (this.counter) this.counter.textContent = this.index + 1;
      if (userInitiated) this.start();
    }

    start() {
      this.stop();
      if (this.reducedMotion || this.slides.length < 2 || Shopify.designMode) return;
      this.timer = setInterval(() => this.go(this.index + 1), this.interval);
    }

    stop() {
      clearInterval(this.timer);
    }
  }

  if (!customElements.get('bz-review-carousel')) {
    customElements.define('bz-review-carousel', BzReviewCarousel);
  }
  } catch(e) { console.error(e); }
})();

})();
